import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0F1C14'
    }
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiDivider: {
      defaultProps: {
        style: {
          margin: 0
        }
      }
    },
    MuiList: {
      defaultProps: {
        style: {
          padding: 0
        }
      }
    },
    MuiMenuList: {
      defaultProps: {
        style: {
          padding: 0
        }
      }
    }
  }
});
